import { appSettings } from "core/config";

const logApiError = (error: any) => {
    try {
        const response = error?.response?.data;

        if (!response) {
            return;
        }

        if (appSettings.isEnabled.logToConsole) {
            console.error(response);
        }
    } catch (ex) {
        console.error("Error logging error", ex);
    }
}

export default logApiError;
